import { useMutation } from '@tanstack/react-query';

import AuthResponse from '@/apiModels/AuthResponse';
import BaseServices from '@/services/BaseServices';
import APIClient from '@/services/APIClient';

const useLogin = ({ cbError, cb, cbSuccess }: IMutationHookProps<AuthResponse>) => {
  const apiClient = new APIClient<FormData>(BaseServices.AUTH_SERVICE, `/auth/business-user-login`);
  return useMutation<AuthResponse, CustomError<RevelErrorResponse>, LoginFormPayload>({
    mutationFn: (payload) => {
      const formData = new FormData();
      formData.append('grant_type', 'password');
      formData.append('client_id', import.meta.env.VITE_CLIENT_ID);
      formData.append('client_secret', import.meta.env.VITE_CLIENT_SECRET);
      formData.append('username', payload.username);
      formData.append('password', payload.password);
      return apiClient.auth<AuthResponse>(formData);
    },
    onSuccess: cbSuccess,
    onError: cbError,
    onMutate: cb,
  });
};

export default useLogin;
